import { $findMatchingParent } from "@lexical/utils";
import { $isRootOrShadowRoot, LexicalNode } from "lexical";
import ToolbarProps from "./ToolbarForEditor";

export const formattingOptions: ToolbarProps.FormattingOption[] = [
  {
    label: "Bold",
    type: "text",
    option: "bold",
    toolTipText: "Bold",
  },
  {
    label: "Italic",
    type: "text",
    option: "italic",
    toolTipText: "Italic",
  },
  {
    label: "Underline",
    type: "text",
    option: "underline",
    toolTipText: "Underline",
  },
  {
    label: "UnOrderList",
    type: "list",
    option: "ul",
    toolTipText: "Bulleted list",
  },
  {
    label: "OrderList",
    type: "list",
    option: "ol",
    toolTipText: "Numbered list",
  },
];

export const $findTopLevelElement = (node: LexicalNode) => {
  let topLevelElement =
    node.getKey() === "root"
      ? node
      : $findMatchingParent(node, (e) => {
          const parent = e.getParent();
          return parent !== null && $isRootOrShadowRoot(parent);
        });

  if (topLevelElement === null) {
    topLevelElement = node.getTopLevelElementOrThrow();
  }
  return topLevelElement;
};

export const styleType = {
  h2: "Heading",
  h3: "SubHeading",
  paragraph: "Paragraph",
};
